<template>
    <div class="login">
        <div class="bg"></div>
        <div class="login-logo" style="position:relative;z-index:99;">
            <img class="logo" src="@/assets/image/login/logo.png"/>
        </div>
        <div class="login-form">
            <!-- <div class="bg-cube"></div>
            <div class="bg-cube-s"></div> -->
            <div class="form-part">
                <div class="form-part-wrap">
                    <div class="form-header">
                        <div class="form-title">{{isChinese?"用户登录":"User Login"}}</div>
                        <!-- <div class="form-lang" @click="isChinese = !isChinese">
                            <span :class="isChinese?'lang-active':''">中</span>/<span
                                :class="isChinese?'':'lang-active'">En</span>
                        </div> -->
                    </div>
                    <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0" class="form-detail">
                        <el-form-item label="" prop="username">
                            <el-input v-model.trim="loginForm.username" autocomplete="off"
                                      :placeholder="isChinese?'账号':'Account'"
                                      @blur="usernameBlur"
                                      @keyup.enter.native="trigger">
                                <i class="iconfont icon-zhanghu" slot="prefix"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" prop="password">
                            <el-input type="password" v-model.trim="loginForm.password" autocomplete="off"
                                      :placeholder="isChinese?'密码':'Password'"
                                      @blur="passwordBlur"
                                      @keyup.enter.native="trigger">
                                <i class="iconfont icon-mima" slot="prefix"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="" prop="remember" style="margin-top: -10px;">
                            <el-checkbox v-model="loginForm.remember">{{isChinese?"记住账号":"Remember the account"}}
                            </el-checkbox>
                        </el-form-item>
                    </el-form>
                    <div>
                        <el-button size="large" type="primary" @click="trigger" v-html="loginBtnName"
                                   :loading="loginBtnLoading"></el-button>
                    </div>
                </div>
            </div>
            <div class="copyright-info">
                Copyright &copy; {{currentYear}} 汇中仪表股份有限公司
            </div>
        </div>
        <el-dialog
                class="verify-dialog"
                append-to-body
                :visible.sync="verifyVisible"
                :show-close="false"
                :close-on-click-modal="false"
                width="450px">
            <slideverify
                    ref="dialogopen"
                    :l="42"
                    :r="10"
                    :w="400"
                    :h="300"
                    :block_y="puzzePass.block_y"
                    :imgurl="puzzePass.imgurl"
                    :miniimgurl="puzzePass.miniimgurl"
                    @success="onSuccess"
                    @fail="onFail"
                    @refresh="onRefresh"
                    :slider-text="puzzePass.text"
                    :isChinese="puzzePass.isChinese"
            >
            </slideverify>
        </el-dialog>
    </div>
</template>
<script>
    import slideverify from '@/components/custom/ImageSlider.vue'
    import img_1 from '@/assets/image/login/1.png'
    import img_11 from '@/assets/image/login/11.png'
    import img_2 from '@/assets/image/login/2.png'
    import img_22 from '@/assets/image/login/22.png'
    import img_3 from '@/assets/image/login/3.png'
    import img_33 from '@/assets/image/login/33.png'
    import img_4 from '@/assets/image/login/4.png'
    import img_44 from '@/assets/image/login/44.png'
    import img_5 from '@/assets/image/login/5.png'
    import img_55 from '@/assets/image/login/55.png'
    import img_6 from '@/assets/image/login/6.png'
    import img_66 from '@/assets/image/login/66.png'
    import img_7 from '@/assets/image/login/7.png'
    import img_77 from '@/assets/image/login/77.png'
    import {set_local_cache, get_local_cache, remove_local_cache} from "@/config/cache/cache.js"
    import {$http} from '@/config/api/axios'
    import {aesEncrypt} from "@/config/utils/aes.js"
    import {Mixins} from '@/config/mixins/mixins'
    import {IsNull} from "../config/validate/common";
    import {set_session_cache} from "@/config/cache/cache.js"

    export default {
        name: 'Login',
        mixins: [Mixins],
        components: {
            slideverify
        },
        data() {
            let currentYear = new Date().getFullYear();
            return {
                language: "zh-CN",
                isChinese: true,
                loginBtnName: '登&ensp;&ensp;&ensp;&ensp;录',
                currentYear: currentYear,
                loginForm: {
                    username: '',
                    password: '',
                    remember: false,
                },
                rules: {
                    username: [
                        {required: true, message: '请输入账号', trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ],
                    remember: [
                        {required: false}
                    ]
                },
                verifyVisible: false, //是否显示验证弹框
                puzzePass: {
                    block_y: 0,    //缺口图片距离上方高度
                    imgurl: '',   //背景图
                    miniimgurl: '', //缺口图
                    text: '按住左边滑块，拖动完成上方拼图',
                    isChinese: true,
                }, // 滑块字段
                errorTimes: 0, //登录错误次数
                isValidate: false,
                verifyInfoArr: [
                    {'imgurl': img_1, 'miniimgurl': img_11, 'block_y': 211, 'x': 164},
                    {'imgurl': img_2, 'miniimgurl': img_22, 'block_y': 195, 'x': 101},
                    {'imgurl': img_3, 'miniimgurl': img_33, 'block_y': 123, 'x': 180},
                    {'imgurl': img_4, 'miniimgurl': img_44, 'block_y': 199, 'x': 170},
                    {'imgurl': img_5, 'miniimgurl': img_55, 'block_y': 165, 'x': 226},
                    {'imgurl': img_6, 'miniimgurl': img_66, 'block_y': 176, 'x': 184},
                    {'imgurl': img_7, 'miniimgurl': img_77, 'block_y': 147, 'x': 237},
                ],
                verifyTestX: '',
                loginBtnLoading: false,
            }
        },
        watch: {
            isChinese: function (val) {
                this.puzzePass.isChinese = val;
                if (val) {
                    this.loginBtnName = '登&ensp;&ensp;&ensp;&ensp;录';
                    this.rules.username[0].message = "请输入账号";
                    this.rules.password[0].message = "请输入密码";
                    this.puzzePass.text = '按住左边滑块，拖动完成上方拼图';
                } else {
                    this.loginBtnName = 'Login';
                    this.rules.username[0].message = "Please enter account";
                    this.rules.password[0].message = "Please input a password";
                    this.puzzePass.text = 'Drag the slider to complete the upper puzzle';
                }
                if (this.isValidate) {
                    this.$refs.loginForm.validate();
                }
            },
            verifyVisible: function (val) {
                if (val === false) {
                    this.verifyTestX = ''
                }
            },
            language: function (val) {
                if (!IsNull(val)){
                    this.isChinese = val !== "en-US";
                }
            }

        },
        methods: {
            usernameBlur() {
                if (this.loginForm.username.length == 0) {
                    this.isValidate = true;
                } else {
                    if (this.loginForm.password.length > 0) {
                        this.isValidate = false;
                    }
                }
            },
            passwordBlur() {
                if (this.loginForm.password.length == 0) {
                    this.isValidate = true;
                } else {
                    if (this.loginForm.username.length > 0) {
                        this.isValidate = false;
                    }
                }
            },
            trigger() {
                this.$refs.loginForm.validate((valid) => {
                    if (valid) {
                        if (this.loginForm.remember) {
                            set_local_cache("username", this.loginForm.username);
                            set_local_cache("rmbUser", "true");
                        } else {
                            set_local_cache("username", this.loginForm.username);
                            set_local_cache("rmbUser", "false");
                        }
                        this.isValidate = false;
                        if (this.errorTimes == 3) {
                            this.verifyVisible = true;
                            this.getImageVerifyCode();
                        } else {
                            var params = {
                                username: this.loginForm.username,
                                password: aesEncrypt(this.loginForm.password)
                            };
                            this.loginBtnLoading = true;
                            $http("post", "/login", params).then((res) => {
                                if (res.status == 'SUCCESS') {
                                    // setCookie("Access-Token", res.data, 24 * 60 * 60);
                                    set_session_cache("Access-Token", res.data);
                                    this.getUserData().then(() => {
                                        if (this.isChinese) {
                                            set_local_cache('language-type', 'zh-CN');
                                            this.$i18n.locale = "zh";
                                            this.$root.$lang = 'zh-CN';
                                        } else {
                                            set_local_cache('language-type', 'en-US');
                                            this.$i18n.locale = "en";
                                            this.$root.$lang = 'en-US';
                                        }
                                        // this.SET_NAV_STABLE(false) // 解决切换登录后左侧导航不能还原的问题
                                        // this.$router.push({path:`${this.$root.$lang}/controller`}); // 采用刷新页面方式跳转为了删除浏览器警告
                                        location.href = location.protocol + '//' + window.location.host + `/${this.$root.$lang}/controller`;
                                    })
                                    this.loginBtnLoading = false;
                                } else {
                                    this.loginBtnLoading = false;
                                    this.errorTimes += 1;
                                    this.$message.error(this.isChinese ? res.message : res.enMessage);
                                }
                            });
                        }
                    } else {
                        this.isValidate = true;
                        return false;
                    }
                });
            },
            onFail() {
                this.onRefresh()
            },
            // 验证码拉动距离返回
            onSuccess(left) {
                if (left > this.verifyTestX - 5 && left < this.verifyTestX + 5) {
                    this.$refs.dialogopen.handleSuccess();
                    setTimeout(() => {
                        this.verifyVisible = false;
                        this.errorTimes = 0;
                        this.trigger();
                    }, 1000);
                } else {
                    this.$refs.dialogopen.handleFail();
                }
            },
            // 刷新验证码
            onRefresh() {
                this.puzzePass.imgurl = '';
                this.puzzePass.miniimgurl = '';
                this.puzzePass.block_y = 0;
                this.getImageVerifyCode();
            },
            getImageVerifyCode() {
                let num = Math.floor(Math.random() * this.verifyInfoArr.length + 1) - 1;
                let imgObj = {
                    block_y: this.verifyInfoArr[num].block_y,
                    imgurl: this.verifyInfoArr[num].imgurl,
                    miniimgurl: this.verifyInfoArr[num].miniimgurl
                };
                this.verifyTestX = this.verifyInfoArr[num].x;
                this.puzzePass.block_y = imgObj.block_y;
                this.puzzePass.imgurl = imgObj.imgurl;
                this.puzzePass.miniimgurl = imgObj.miniimgurl;
                setTimeout(() => {
                    this.$refs.dialogopen && this.$refs.dialogopen.reset(this.puzzePass.block_y);
                }, 10);
            },
            //登录成功后获取用户信息
            async getUserData() {
                await $http("get", "user/getSelfUserData", {}).then((res) => {
                    if (res.status == 'SUCCESS') {
                        set_local_cache("tokenUser", res.data);
                        remove_local_cache('consumer_' + res.data.tokenUserId)
                    } else {
                        this.$message.error(this.isChinese ? res.message : res.enMessage);
                    }
                });
            },
        },
        mounted() {
            //获取cache的值
            this.language = get_local_cache("language-type");
            let username = get_local_cache('username');
            let rmbUser = get_local_cache('rmbUser');
            if (rmbUser != null && rmbUser == 'true') {
                this.loginForm.remember = true;
                if (username == undefined) {
                    username = "";
                    this.loginForm.password = "";
                    this.loginForm.remember = false;
                }
                this.loginForm.username = username;
            }
            this.$store.commit('Home/RESET_STATE');
            this.pageLoading(false)
            document.getElementsByTagName('title')[0].textContent = '汇中表务管理系统';
        }
    }
</script>
<style lang="less" scoped>
 @image:'../assets/image/login';
    .login {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        // overflow: hidden;
        .bg {
            position: absolute;
            width: 55%;
            height: 90%;
            background: url("@{image}/bg.png") no-repeat center;
            background-size: 100% 100%;
            left: 55px;
            top: 6%;
            z-index: 10;
        }

        .login-logo {
            float: left;
            width: 56.2%;
            height: 100%;
            padding: 6% 0 0 90px;

            img {
                width: 40%;
            }
        }

        .login-form {
            position: relative;
            z-index: 1;
            float: left;
            width: 43.8%;
            height: 100%;
            background-color: #F4F5F7;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow-y: auto;
            background: url("@{image}/bgleft.png") no-repeat center;
            background-size: 100% 100%;
            .bg-cube {
                position: absolute;
                width: 29%;
                background-color: #e5e7fe;
                border-radius: 3px;
                top: 12%;
                left: 9%;
            }

            .bg-cube:after {
                display: block;
                padding-top: 100%;
                content: '';
            }

            .bg-cube-s {
                position: absolute;
                width: 19.5%;
                background-color: #e5e7fe;
                border-radius: 3px;
                bottom: 12%;
                right: 9%;
            }

            .bg-cube-s:after {
                display: block;
                padding-top: 100%;
                content: '';
            }

            .form-part {
                position: relative;
                width: 520px;
                height: 600px;
                background-color: #fff;
                border-radius: 4px;
                padding: 100px 60px;
                box-shadow: 10px 10px 15px #4430603d;
                opacity: 0;
                animation: loginShow 0.6s linear forwards;
                z-index: 11;
                @media screen and (max-width: 1440px) {
                    width: 430px;
                    height: 490px;
                    padding: 60px 60px;
                }

                .form-part-wrap {
                    position: relative;
                    width: 100%;
                    height: 100%;

                    .form-header {
                        .form-title {
                            float: left;
                            font-size: 28px;
                            color: #000;
                            font-weight: lighter;
                        }

                        .form-lang {
                            float: right;
                            font-size: 28px;
                            color: #888;
                            font-weight: lighter;
                            cursor: pointer;

                            .lang-active {
                                color: #000;
                            }
                        }
                    }

                    .form-detail {
                        clear: both;
                        padding-top: 10%;

                        /deep/ .el-input__inner {
                            height: 62px;
                            line-height: 62px;
                            border-color: #bbb;
                            border-radius: 30px;
                            text-indent: 30px;
                            font-size: 16px;
                            color: #666;
                        }

                        /deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
                            margin-bottom: 30px;
                        }

                        /deep/ .el-form-item--small .el-form-item__error {
                            padding-top: 5px;
                        }

                        /deep/ .el-form-item__error {
                            font-size: 14px;
                            left: 35px;
                        }

                        /deep/ .el-input__prefix {
                            left: 30px;
                            line-height: 62px;
                        }

                        /deep/ .el-checkbox__inner {
                            width: 16px;
                            height: 16px;
                            border-radius: 6px;
                            border-color: #bbb;
                        }

                        /deep/ .el-checkbox__label {
                            font-size: 16px;
                            color: #9e9e9e;
                        }

                        /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
                            color: #6790ff;
                        }

                        /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
                            background-color: #6790ff;
                            border-color: #6790ff;
                        }

                        /deep/ .el-checkbox__inner::after {
                            top: 2px;
                            left: 5px;
                        }

                        /deep/ .el-checkbox__input {
                            margin-left: 5px;
                        }
                        .iconfont {
                            font-size: 20px;
                            color: #bbb;
                        }
                    }

                    /deep/ .el-button {
                        width: 100%;
                        height: 62px;
                        border-radius: 30px;
                        font-size: 22px;
                        position: absolute;
                        bottom: 0;
                    }
                }

                /deep/ .el-input__inner {
                    border: 1px solid #DCDFE6;
                    background-color: #fff;
                }
            }
        }

        .copyright-info {
            position: absolute;
            font-size: 17px;
            font-weight: lighter;
            letter-spacing: 1px;
            font-family: Arial;
            color: #8a8b8d;
            width: 100%;
            text-align: center;
            bottom: 40px;
            z-index: 10;
        }
    }
</style>
<style>
    .verify-dialog .el-dialog .el-dialog__header {
        display: none;
    }

    @keyframes loginShow {
        0% {
            margin-top: -22%;
            opacity: 0;
        }
        100% {
            margin-top: 0;
            opacity: 1;
        }
    }
</style>
